
import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import PropTypes from "prop-types";

const AddFoodTypeForm = ({
    values = {},
    errors = {},
    handleChange = () => { },
    handleSubmit = () => { },
    loading = false,
    fields = [],
}) => {

    return (
        <PageBody onSubmit={handleSubmit} headerchildren={
            <HeadingOne>Add Food Categories</HeadingOne>
        }>
            {fields.map((field) => {

                return (
                    <FormInput
                        key={field.name}
                        field={field}
                        value={values[field.name]}
                        handleChange={handleChange}
                        error={errors[field.name]}
                    />
                );
            })}

            <FormSubmitButton
                label="Create"
                loading={loading}
                colSize="col-12"
                align="end"
            />
        </PageBody>
    );
};

AddFoodTypeForm.propTypes = {
    values: PropTypes.object,
    errors: PropTypes.object,
    handleChange: PropTypes.func,
    handleSubmit: PropTypes.func,
    loading: PropTypes.bool,
    fields: PropTypes.array,
};

AddFoodTypeForm.defaultProps = {
    values: {},
    errors: {},
    handleChange: () => { },
    handleSubmit: () => { },
    loading: false,
    fields: [],
};

export default AddFoodTypeForm;
